import MenuItem from './MenuItem';
import { Box, Divider, IconButton, Stack, Typography } from '@mui/material';
// import WaitingCard from './WaitingCard';
import { ArrowBackIosNew, ArrowForwardIos } from '@mui/icons-material';
import MenuItemMobile from './MenuItemMobile';
import StyleDrawer from './StyleDrawer';
import useScreenWidth from '../../../hooks/use-page-width';
import { useEffect } from 'react';
// import { DocumentGroup } from '../../../pages/documents/models/destination.model';
// import axiosInstance from '../../../configs/axios';
// import { ApiPath } from '../../../constants/apiPath';
import checkAuthController from '../controllers/check-auth.controller';
import { UserInfoModel } from '../../../pages/user/models/user.model';

interface IProps {
  open: boolean;
  toggleDrawer: () => void;
}

const CustomDrawer = ({ open, toggleDrawer }: IProps) => {
  const width = useScreenWidth();
  const checkUser = checkAuthController();
  useEffect(() => {
    checkUser.getLoginUser();
  }, []);

  const user: UserInfoModel | null = checkUser.loginUser;

  return (
    <StyleDrawer variant="permanent" open={open && width > 1024}>
      {open && width > 1024 ? (
        <DeskTop user={user} toggleDrawer={toggleDrawer} />
      ) : (
        <Mobile user={user} toggleDrawer={toggleDrawer} />
      )}
    </StyleDrawer>
  );
};

const DeskTop = ({ toggleDrawer, user }: { toggleDrawer: any; user: UserInfoModel | null }) => {
  // const [setDocs] = useState<DocumentGroup[]>([]);

  // const getPending = async () => {
  //   try {
  //     const res = await axiosInstance.get(ApiPath.destinations.all, {
  //       params: { skip: 0, take: 2, tracking_status: 'PENDING' },
  //     });

  //     // const filteredData: any = res?.data?.data ?? [];
  //     // setDocs(filteredData);
  //   } catch (error) {
  //     // setDocs([]);
  //   }
  // };
  // useEffect(() => {
  // getPending();
  // }, []);
  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography fontSize={26}>MSEG Flow</Typography>
        <IconButton onClick={toggleDrawer}>
          <ArrowBackIosNew
            sx={{
              color: 'black',
              fontSize: 20,
              backgroundColor: '#E0E0E0',
              p: 0.5,
              borderRadius: 30,
            }}
          />
        </IconButton>
      </Box>
      <Box>
        <MenuItem user={user} onPressed={() => {}} />

        {/* <Divider sx={{ py: 1 }} /> */}
        {/* <Divider sx={{ py: 1 }} /> */}

        {/* <Typography sx={{ py: 2 }}>ເອກະສານລໍຖ້າ ({docs.length ?? '0'})</Typography>

        <Stack spacing={1}>
          {docs?.length > 0 &&
            docs?.map((items, index) => {
              if (index < 2) {
                return <WaitingCard key={index} item={items} />;
              }
            })}
        </Stack> */}
      </Box>
      <Box flex={1} display={'flex'} marginBottom={'20px'} />
      <Divider sx={{ marginBottom: '20px' }} />
      <Typography style={{ fontSize: 13, marginBottom: '10px', color: '#486BC2' }}>
        Support by Sivilltech co.,ltd
      </Typography>
    </>
  );
};

const Mobile = ({ toggleDrawer, user }: { toggleDrawer: any; user: UserInfoModel | null }) => {
  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <IconButton onClick={toggleDrawer}>
          <ArrowForwardIos
            sx={{
              color: 'black',
              fontSize: 20,
              backgroundColor: '#E0E0E0',
              p: 0.5,
              borderRadius: 30,
            }}
          />
        </IconButton>
      </Box>

      <Box>
        <MenuItemMobile user={user} />

        <Divider sx={{ py: 1 }} />
        <Divider sx={{ py: 1 }} />

        <Stack spacing={1} sx={{ p: 2 }}>
          <Box sx={{ width: '10px', height: '10px', borderRadius: 5, backgroundColor: 'red' }} />
          <Box sx={{ width: '10px', height: '10px', borderRadius: 5, backgroundColor: 'red' }} />
        </Stack>
      </Box>
    </Box>
  );
};

export default CustomDrawer;
